import styled from 'styled-components'

import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'

export const Container = styled.div(({ theme }) => ({
  alignItems: 'center',
  columnGap: theme.space['16'],
  display: 'grid',
  gridTemplateAreas: `". startLabel endLabel ." "title start end download" ". message message ."`,
  gridTemplateColumns: 'auto 15rem 15rem auto',
  gridTemplateRows: '1fr auto 1fr',
  marginLeft: theme.space['32'],
  rowGap: theme.space['4'],
}))

export const Title = styled(Typography)(({ theme }) => ({
  borderLeft: `${theme.border.size['2']} solid ${theme.colors.black}`,
  fontSize: '1.5rem',
  gridArea: 'title',
  lineHeight: '2.1rem',
  paddingLeft: theme.space['8'],
}))

export const FieldLabel = styled.div<{ $area: 'endLabel' | 'startLabel' }>(({ $area }) => ({
  alignSelf: 'end',
  gridArea: $area,
}))

export const Field = styled.div<{ $area: 'end' | 'start' }>(({ $area }) => ({
  gridArea: $area,
}))

export const Message = styled.div({
  alignSelf: 'start',
  gridArea: 'message',
  height: 0,
})

export const DownloadButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.colors.black,
  gridArea: 'download',
  paddingBlock: theme.space['6'],
  paddingInline: theme.space['16'],
}))
